import { render, staticRenderFns } from "./SmsCreditBalance.vue?vue&type=template&id=e815a246&scoped=true"
import script from "./SmsCreditBalance.vue?vue&type=script&lang=js"
export * from "./SmsCreditBalance.vue?vue&type=script&lang=js"
import style0 from "./SmsCreditBalance.vue?vue&type=style&index=0&id=e815a246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e815a246",
  null
  
)

export default component.exports